var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5558 9.5918V12.016C13.5558 12.3375 13.42 12.6458 13.1783 12.8731C12.9365 13.1005 12.6086 13.2282 12.2668 13.2282H3.24318C2.9013 13.2282 2.57341 13.1005 2.33166 12.8731C2.08992 12.6458 1.9541 12.3375 1.9541 12.016V9.5918",
    stroke: "white",
    strokeWidth: 1.21212,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9776 5.35062L7.75493 2.32031L4.53223 5.35062",
    stroke: "white",
    strokeWidth: 1.21212,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75439 2.32031V9.59304",
    stroke: "white",
    strokeWidth: 1.21212,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.c822c5ac35bf2f01d6c31b58002b01bd.svg";
export { ForwardRef as ReactComponent };